import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

import getCommentsQuery from "@apps/comments/graphql/get-comments-query";
import cache from "@cache/cache";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherCommentAddedOrUpdated({
  channelName,
}: {
  channelName: string;
}) {
  const [fetchComments] = useLazyQuery(getCommentsQuery, {});

  const handleCommentAddedOrUpdated = useCallback(
    ({
      topic,
      artifact,
    }: {
      topic: { id: number };
      artifact: { id: number };
    }) => {
      if (topic) {
        const topicCacheId = cache.identify(topic);
        if (topicCacheId) {
          fetchComments({ variables: { topicId: topic.id } });
        }
      }
      if (artifact) {
        const artifactCacheId = cache.identify(artifact);
        if (artifactCacheId) {
          fetchComments({ variables: { artifactId: artifact.id } });
        }
      }
    },
    [fetchComments],
  );

  usePusher(channelName, "comment_added", handleCommentAddedOrUpdated);
  usePusher(channelName, "comment_updated", handleCommentAddedOrUpdated);
  return null;
}
